import React from 'react';
import styles from './PricingSection.module.scss';
import SectionBadge from '../components/SectionBadge';
import PricingCard from '../components/PricingCard';

const ProIcon = () => (
  <svg width="28" height="28" viewBox="0 0 28 28" fill="none">
    <path
      d="M14 2L3.5 7.5V14C3.5 20.3 8.03 26.18 14 27.5C19.97 26.18 24.5 20.3 24.5 14V7.5L14 2Z"
      stroke="#00A7B7"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9 14L12.5 17.5L19 11"
      stroke="#00A7B7"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const BusinessIcon = () => (
  <svg width="28" height="28" viewBox="0 0 28 28" fill="none">
    <path
      d="M14 2L3.5 7.5V14C3.5 20.3 8.03 26.18 14 27.5C19.97 26.18 24.5 20.3 24.5 14V7.5L14 2Z"
      stroke="#7A5AF8"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9 14L12.5 17.5L19 11"
      stroke="#7A5AF8"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14 8V14L17.5 17.5"
      stroke="#7A5AF8"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const PricingSection = ({ onGetAccessPro, onGetAccessBusiness }) => {
  const proFeatures = [
    'Unlimited AI-powered content campaigns',
    'AI-powered briefs',
    'AI content templates',
    'Channel integrations',
    'Unlimited brand voices',
    'Content scoring',
    'Multi-model text editor',
    'VIP community features',
    'Priority customer support',
  ];

  const businessFeatures = [
    'Comes with 4 Vocable accounts',
    'Advanced collaboration features',
    'Share brand voices',
    'Link sharing with clients',
    'Advanced brand intelligence/training',
  ];

  return (
    <section className={styles.pricing}>
      <div className={styles.container}>
        <div className={styles.header}>
          <SectionBadge>Plans</SectionBadge>
          <h2 className={styles.headline}>
            Get lifetime access to the AI content system that saves you 20hrs/week
          </h2>
        </div>

        <div className={styles.cards}>
          <PricingCard
            icon={<ProIcon />}
            title="Lifetime Pro"
            subtitle="Great for entrepreneurs, creators and freelancers."
            price="399"
            savings="1,257"
            features={proFeatures}
            featuresTitle="Features"
            variant="default"
            onGetAccess={onGetAccessPro}
          />
          <PricingCard
            icon={<BusinessIcon />}
            title="Lifetime Business"
            subtitle="Great for agencies and teams creating together."
            price="899"
            savings="3,329"
            features={businessFeatures}
            featuresTitle="Everything on lifetime pro, plus:"
            variant="business"
            onGetAccess={onGetAccessBusiness}
          />
        </div>
      </div>
    </section>
  );
};

export default PricingSection;
